<div class="loader">
    <div class="loaderBar"></div>
</div>